import React from "react";
import useLenis from "@/lib/useLenis";
import useSeo, { SEO_SITE_URL } from "@/lib/useSeo";
import { useLang } from "@/lib/LangContext";
import Nav, { HashScrollBoot } from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Journey from "@/components/site/Journey";
import Services from "@/components/site/Services";
import WhatWeMake from "@/components/site/WhatWeMake";
import WhatWeDontMake from "@/components/site/WhatWeDontMake";
import Trust from "@/components/site/Trust";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  const { lang } = useLang();

  const title =
    lang === "en"
      ? "Emergent Food — Food Manufacturing as a Service · Europe"
      : "Emergent Food — Food Manufacturing as a Service · Europa";
  const description =
    lang === "en"
      ? "Emergent Food is the European Food Manufacturing as a Service partner for food startups, D2C brands, chains and private label. We develop, industrialise, produce and ship. CE-approved facility, 27 EU markets."
      : "Emergent Food è il partner europeo di Food Manufacturing as a Service per startup food, brand D2C, catene e private label. Sviluppiamo, industrializziamo, produciamo, spediamo. Laboratorio Bollo CE, 27 paesi UE.";

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Emergent Food",
      url: SEO_SITE_URL,
      logo: `${SEO_SITE_URL}/logo.png`,
      description,
      foundingLocation: "Milan, Italy",
      areaServed: "European Union",
      sameAs: [],
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Food Manufacturing as a Service",
      serviceType: "Contract Manufacturing, Private Label, Product Development",
      provider: { "@type": "Organization", name: "Emergent Food" },
      areaServed: [
        "Italy", "Germany", "France", "Spain", "Netherlands", "Belgium",
        "Austria", "Portugal", "Poland", "Sweden", "Denmark", "Finland",
      ],
      offers: {
        "@type": "OfferCatalog",
        name: "FMaaS Services",
        itemListElement: [
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Product Development" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Industrialisation" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Contract Manufacturing" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Private Label" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Packaging" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Scale Production" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Logistics" } },
        ],
      },
    },
  ];

  useSeo({ title, description, path: "/", lang, jsonLd });

  return (
    <div className="App grain min-h-screen bg-[#050505] text-white relative" data-testid="landing-root">
      <HashScrollBoot />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Journey />
        <Services />
        <WhatWeMake />
        <WhatWeDontMake />
        <Trust />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
